import { useParams, Navigate } from 'react-router-dom';
import { CenterWiseResultsHeader, CenterWiseResultsTable } from './components';
import { getAccess } from '@utils/accessControl';

export default function CenterWiseResults() {
  const params = useParams();

  if (
    getAccess(params?.constituencyId ? Number(params?.constituencyId) : null)
  ) {
    return (
      <div className="pt-10">
        <CenterWiseResultsHeader />
        <CenterWiseResultsTable />
      </div>
    );
  } else {
    return <Navigate to="/no-match" replace={true} />;
  }
}
